enum CookieSameSiteEnum {
	strict = 'Strict',
	lax = 'Lax',
	none = 'None'
}
export default CookieSameSiteEnum;
